import React, { useState, useEffect, useRef } from "react";
import {
  Button,
  Space,
  Typography,
  Divider,
  Row,
  Col,
  Input,
  message,
} from "antd";
import {
  PictureOutlined,
  CloudOutlined,
  AppstoreOutlined,
  ColumnWidthOutlined,
  CheckOutlined,
  FundProjectionScreenOutlined,
} from "@ant-design/icons";

import { sendViewMode, connectWebSocket } from "../components/SocketSender";
import Messages from "../components/Messages";
import checkCookie from "../utils/cookieManager";
import RaumControls from "../components/RaumControls";
const { Title } = Typography;

const DMCPanel = () => {
  const [socket, setSocket] = useState(null);
  const [sessionValue, setSessionValue] = useState(null);
  const sessionActiveRef = useRef(false);
  const sessionRef = useRef(checkCookie("session_id"));
  const [sessionActive, setSessionActive] = useState(false);

  const {
    showMessageError,
    showMessageWarning,
    showMessageInfo,
    showMessageSuccess,
    messageHolder,
  } = Messages();
  useEffect(() => {
    // TODO: check if session already exists upon page refresh
    const initSocket = async () => {
      const socketConnection = await connectWebSocket();
      setSocket(socketConnection);

      // Add connection event listeners
      socketConnection.on("connect", () => {
        console.log("Socket connected");
      });

      socketConnection.on("disconnect", () => {
        console.log("Socket disconnected");
      });
      checkSession();
    };

    initSocket();

    // Cleanup function
    return () => {
      if (socket) {
        socket.off("user-joined");
        socket.off("session-error");
        socket.off("session-info");
        socket.off("session-disconnected");
        socket.disconnect();
      }
    };
  }, []);

  const checkSession = async () => {
    try {
      // debugger;
      // const existingSession = checkCookie('session_id');
      console.log("checked existing session:", sessionRef.current);
      if (sessionRef.current !== null) {
        setSessionValue(sessionRef.current);
        sessionActiveRef.current = true;
        console.log("sessionValue:", sessionValue);
        await handleJoinSession();
        // sessionRef.current = existingSession;

        const sessionInfo = await handleSessionInfo();
        console.log("sessionInfo:", sessionInfo);
        if (sessionInfo === null) {
          setSessionActive(false);
          sessionActiveRef.current = false;
          setSessionValue(null);
          sessionRef.current = null;
        } else {
          sessionRef.current = sessionInfo;
          setSessionValue(sessionInfo);
          sessionActiveRef.current = true;
          console.log("sessionActive:", sessionActive);
        }
      } else {
        sessionActiveRef.current = false;
      }
    } catch (error) {
      console.error("Error checking existing session:", error);
    }
  };
  const handleClick = (mode) => {
    sendViewMode(mode);
  };

  const handleJoinSession = async () => {
    // debugger;

    try {
      // socket.emit("join-session", sessionValue);
      if (socket) {
        const jsocket = await connectWebSocket();
        console.log("jsocket", jsocket);
        setSocket(jsocket);
      }
      console.log("handleJoinSession:::", sessionValue);
      if (sessionValue === null)
        socket.emit("join-session", sessionRef.current);
      else socket.emit("join-session", sessionValue);

      socket.on("user-joined", (id) => {
        console.log("Session joined:", sessionValue);
        console.log(`New user joined:`, id.session_id);
        showMessageSuccess(`New user joined:${id.session_id}`);
        setSessionActive(true);
        sessionActiveRef.current = true;
        sessionRef.current = sessionValue;
        const now = new Date();
        now.setTime(now.getTime() + 4 * 60 * 60 * 1000); // 4 hours in milliseconds or max-age=14400; 14400 seconds = 4 hours
        document.cookie = `session_id=${sessionValue}; expires=${now.toUTCString()}; path=/`;
      });
      socket.on("session-error", (msg) => {
        showMessageError(msg);
      });
    } catch (error) {
      console.error("Error joining session:", error);
      // if (!socket) return;
    }
  };
  const handleSessionDisconnection = async () => {
    document.cookie =
      "session_id=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";

    // if (!socket) return;
    // const socket = await connectWebSocket();
    await socket.emit("disconnect-session", sessionValue);
    await socket.on("session-disconnected", (msg) => {
      console.log("session-disconnected:::", msg);
      showMessageInfo(msg);
      setSessionActive(false);
      setSessionValue(null);
      sessionActiveRef.current = false;
      sessionRef.current = null;
    });
  };

  const handleSessionInfo = async () => {
    // if (!socket) return;
    return new Promise((resolve) => {
      socket.emit("get-session-info", sessionRef.current);
      socket.on("session-info", (msg) => {
        // message.success(msg);
        if (msg === "no-session") {
          resolve(null);
        } else {
          console.log("Active Session: ", msg);
          setSessionActive(true);
          sessionActiveRef.current = true;
          setSessionValue(msg);
          sessionRef.current = msg;
          resolve(msg); // return the message
        }
      });
    });
  };
  return (
    <div
      className="auth"
      style={{
        maxWidth: window.innerWidth,
        margin: "0 auto",
        padding: "0 16px",
      }}
    >
      <div style={{ maxWidth: 640, margin: "0 auto", padding: "20px 0" }}>
        <Title level={2}>
          <span>
            <FundProjectionScreenOutlined /> Mediensteuerungspanel
          </span>
        </Title>

        <Divider />

        <Row style={{ margin: "32px 0px 0px 0px", textAlign: "right" }}>
          {sessionActiveRef.current ? (
            <>
              <Title level={5}>
                Connected to Session: {sessionRef.current}
              </Title>
              <Button onClick={handleSessionDisconnection}>X</Button>
              <Button onClick={handleSessionInfo}>Info</Button>
            </>
          ) : (
            <>
              <div>
                <Input
                  placeholder="Session ID"
                  style={{ width: "20vw" }}
                  value={sessionValue}
                  onChange={(e) => setSessionValue(e.target.value)}
                />
                <Button
                  style={{ margin: "0px 0px 0px 16px", textAlign: "right" }}
                  onClick={handleJoinSession}
                >
                  <CheckOutlined />
                </Button>
              </div>
            </>
          )}
        </Row>

        <Row>
          <Col span={8}>
            <Divider orientation="left">Ansicht wechseln</Divider>
            <Space direction="vertical" size="middle" style={{ width: "100%" }}>
              <Button
                icon={<ColumnWidthOutlined />}
                block
                onClick={async () => {
                  const sessionInfo = await handleSessionInfo();
                  if (sessionInfo === sessionValue && sessionInfo !== null) {
                    handleClick("split");
                  } else {
                    showMessageWarning("No session connected!");
                  }
                }}
              >
                Geteilte Ansicht
              </Button>

              <Button
                icon={<CloudOutlined />}
                block
                onClick={async () => {
                  const sessionInfo = await handleSessionInfo();
                  if (sessionInfo === sessionValue && sessionInfo !== null) {
                    handleClick("wordcloud");
                  } else {
                    showMessageWarning("No session connected!");
                    setSessionActive(false);
                    setSessionValue(null);
                  }
                }}
              >
                Nur Wortwolke
              </Button>

              <Button
                icon={<CloudOutlined />}
                block
                onClick={async () => {
                  const sessionInfo = await handleSessionInfo();
                  if (sessionInfo === sessionValue && sessionInfo !== null) {
                    handleClick("cleanwordcloud");
                  } else {
                    showMessageWarning("No session connected!");
                    setSessionActive(false);
                    setSessionValue(null);
                  }
                }}
              >
                Leere Wortwolke
              </Button>

              <Button
                icon={<PictureOutlined />}
                block
                onClick={async () => {
                  const sessionInfo = await handleSessionInfo();
                  if (sessionInfo === sessionValue && sessionInfo !== null) {
                    handleClick("illustration");
                  } else {
                    showMessageWarning("No session connected!");
                    setSessionActive(false);
                    setSessionValue(null);
                  }
                }}
              >
                Nur Illustration
              </Button>
            </Space>

            <Divider orientation="left">Mehrfachansichten</Divider>

            <Space direction="vertical" size="middle" style={{ width: "100%" }}>
              <Button
                icon={<AppstoreOutlined />}
                block
                onClick={async () => {
                  const sessionInfo = await handleSessionInfo();
                  if (sessionInfo === sessionValue && sessionInfo !== null) {
                    handleClick("multiwordcloud");
                  } else {
                    showMessageWarning("No session connected!");
                    setSessionActive(false);
                    setSessionValue(null);
                  }
                }}
              >
                4x Wortwolke anzeigen
              </Button>
              <Button
                icon={<AppstoreOutlined />}
                block
                onClick={async () => {
                  const sessionInfo = await handleSessionInfo();
                  if (sessionInfo === sessionValue && sessionInfo !== null) {
                    handleClick("multiillustration");
                  } else {
                    showMessageWarning("No session connected!");
                    setSessionActive(false);
                    setSessionValue(null);
                  }
                }}
              >
                4x Illustration anzeigen
              </Button>
            </Space>
          </Col>
          <Col span={16}>
            <Divider orientation="left">Raumeinstellungen</Divider>
            <Space
              direction="vertical"
              size="middle"
              style={{ width: "100%", maxHeight: "39vh", overflowY: "auto" }}
            >
              {sessionRef.current && (
                <RaumControls sessionID={sessionRef.current} />
              )}
            </Space>
          </Col>
        </Row>
      </div>
    </div>
  );
};

export default DMCPanel;
